import { render, staticRenderFns } from "./applicationForCollection.vue?vue&type=template&id=d08900d2&scoped=true&"
import script from "./applicationForCollection.vue?vue&type=script&lang=js&"
export * from "./applicationForCollection.vue?vue&type=script&lang=js&"
import style0 from "./applicationForCollection.vue?vue&type=style&index=0&id=d08900d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08900d2",
  null
  
)

export default component.exports